<template>
  <!-- ====================== SEÇÃO: PALESTRANTES ====================== -->
  <section class="speakers-content mt-10 mb-10 px-4 lg:px-0" id="palestrantes">
    <div class="max-w-screen-xl mx-auto">
      <!-- Título + Linhas -->
      <div class="mb-8">
        <div class="flex items-center gap-2 relative pb-3">
          <div>
            <h2 class="text-lg md:text-xl font-medium tracking-wide"
              :style="{ color: customization?.section_title_color || '#1c243b' }">
              {{ customization?.speakers_title || 'Palestrantes' }}
            </h2>
            <h2 class="text-xs md:text-sm font-normal tracking-wide"
              :style="{ color: customization?.section_subtitle_color || '#666666' }">
              {{ customization?.speakers_subtitle || 'Confira abaixo o que preparamos para esse dia especial' }}
            </h2>
          </div>
          <div class="absolute bottom-0 left-0 w-full h-px bg-gray-200"></div>
          <div class="absolute bottom-0 left-0 h-px w-full max-w-[480px]"
            :style="{ backgroundColor: customization?.section_divider_color || '#e5e7eb' }"></div>
        </div>
      </div>

      <!-- Grid de Palestrantes -->
      <div v-if="speakers && speakers.length > 0" class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div v-for="speaker in speakers" :key="speaker.id" @click="openSpeakerModal(speaker)"
          class="group bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer overflow-hidden border border-gray-100">
          
          <div class="relative overflow-hidden">
            <div class="aspect-w-1 aspect-h-1">
              <img :src="speaker.photo" :alt="speaker.name"
                class="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div v-if="speaker.international"
              class="absolute top-4 right-4 bg-gradient-to-r from-yellow-400 to-amber-500 text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1 shadow-lg">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              Internacional
            </div>
          </div>

          <div class="p-6 text-center">
            <!-- NOME DO PALESTRANTE NO GRID → usa font_color -->
            <h3 class="text-sm font-medium mb-1" :style="{ color: fontColor }">
              {{ speaker.name }}
            </h3>
            <p class="text-xs text-gray-600 leading-snug">{{ speaker.role }}</p>
            <div v-if="speaker.company_logo" class="mt-5 flex justify-center">
              <img :src="speaker.company_logo" alt="Company Logo" class="h-8 w-auto object-contain opacity-70" />
            </div>
          </div>
        </div>
      </div>

      <div v-else class="text-center py-12">
        <p class="text-gray-500">Nenhum palestrante cadastrado ainda.</p>
      </div>
    </div>

    <!-- MODAL DO PALESTRANTE -->
    <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm" @click="closeModal">
      <div class="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full overflow-hidden" @click.stop>
        <button @click="closeModal"
          class="absolute top-4 right-4 z-10 bg-gray-100 hover:bg-gray-200 rounded-lg p-2 transition">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>

        <div class="grid md:grid-cols-3">
          <div class="bg-gray-50 p-6 md:p-8 flex flex-col items-center justify-center">
            <img :src="selectedSpeaker.photo" :alt="selectedSpeaker.name"
              class="w-48 h-48 md:w-64 md:h-64 rounded-xl object-cover shadow-xl border-4 border-white mb-4 md:mb-6" />
            <img v-if="selectedSpeaker.company_logo" :src="selectedSpeaker.company_logo" class="h-5 md:h-6 w-auto object-contain" />
          </div>

          <div class="md:col-span-2 p-6 md:p-10">
            <!-- NOME DO PALESTRANTE NO MODAL → usa font_color -->
            <h3 class="text-lg md:text-xl font-semibold mb-2" :style="{ color: fontColor }">
              {{ selectedSpeaker.name }}
            </h3>
            <p class="text-sm text-gray-600 mb-6">{{ selectedSpeaker.role }}</p>

            <!-- BOTÕES DE REDES SOCIAIS - HOVER INDEPENDENTE -->
            <div v-if="selectedSpeaker.social_media" class="flex flex-wrap gap-3 mb-8">
              <!-- LinkedIn -->
              <a v-if="selectedSpeaker.social_media.linkedin"
                 :href="selectedSpeaker.social_media.linkedin" target="_blank"
                 class="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300"
                 :style="socialButtonStyle('linkedin')"
                 @mouseenter="hoveredIcon = 'linkedin'"
                 @mouseleave="hoveredIcon = null">
                <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>

              <!-- Instagram -->
              <a v-if="selectedSpeaker.social_media.instagram"
                 :href="selectedSpeaker.social_media.instagram" target="_blank"
                 class="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300"
                 :style="socialButtonStyle('instagram')"
                 @mouseenter="hoveredIcon = 'instagram'"
                 @mouseleave="hoveredIcon = null">
                <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.258-.149-4.771-1.699-4.919-4.92-.058-1.265-.069-1.644-.069-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.98-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>

              <!-- Twitter/X -->
              <a v-if="selectedSpeaker.social_media.twitter"
                 :href="selectedSpeaker.social_media.twitter" target="_blank"
                 class="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300"
                 :style="socialButtonStyle('twitter')"
                 @mouseenter="hoveredIcon = 'twitter'"
                 @mouseleave="hoveredIcon = null">
                <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 5.332c-.856.382-1.771.64-2.73.757 1.02-.61 1.788-1.574 2.154-2.72-.954.565-2.005.976-3.127 1.197-.898-.957-2.178-1.555-3.594-1.555-2.723 0-4.928 2.203-4.928 4.922 0 .386.044.762.128 1.124-4.096-.205-7.728-2.166-10.148-5.143-.424.726-.666 1.561-.666 2.457 0 1.697.865 3.197 2.178 4.075-.803-.025-1.558-.246-2.218-.614v.061c0 2.368 1.685 4.342 3.922 4.792-.41.112-.843.172-1.288.172-.315 0-.622-.031-.92-.088.622 1.94 2.425 3.352 4.56 3.393-1.674 1.309-3.774 2.089-6.062 2.089-.394 0-.782-.023-1.17-.068 2.179 1.394 4.768 2.209 7.548 2.209 9.057 0 14.006-7.496 14.006-13.986 0-.213-.005-.426-.014-.638.96-.693 1.795-1.56 2.456-2.548l-.007-.003z"/>
                </svg>
              </a>

              <!-- Website -->
              <a v-if="selectedSpeaker.social_media.website"
                 :href="selectedSpeaker.social_media.website" target="_blank"
                 class="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300"
                 :style="socialButtonStyle('website')"
                 @mouseenter="hoveredIcon = 'website'"
                 @mouseleave="hoveredIcon = null">
                <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 16.057v-3.057h2.994c-.059 1.143-.212 2.24-.456 3.279-.823-.12-1.674-.188-2.538-.222zm1.957 2.162c-.499 1.33-1.159 2.497-1.957 3.456v-3.62c.666.028 1.319.081 1.957.164zm-1.957-7.219v-3.015c.868-.034 1.721-.103 2.548-.224.238 1.027.389 2.111.446 3.239h-2.994zm0-5.014v-3.661c.806.969 1.471 2.15 1.971 3.496-.642.084-1.3.137-1.971.165z"/>
                </svg>
              </a>
            </div>

            <h4 class="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">Biografia</h4>
            <p class="text-gray-700 leading-relaxed text-sm whitespace-pre-line max-h-60 md:max-h-96 overflow-y-auto">{{ selectedSpeaker.bio }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useLandingPage } from '@/composables/useLandingPage'

const { speakers, customization } = useLandingPage()

// Cor principal do texto (usada no nome do palestrante)
const fontColor = computed(() => customization.value?.font_color || '#1f2937')

const showModal = ref(false)
const selectedSpeaker = ref({})
const hoveredIcon = ref(null)

// Estilo do botão social (hover independente por ícone)
const socialButtonStyle = (iconName) => {
  const isHovered = hoveredIcon.value === iconName
  const baseColor = customization.value?.button_color || '#2563eb'
  const hoverColor = customization.value?.button_hover_color || baseColor

  return {
    backgroundColor: isHovered ? hoverColor : baseColor,
    transition: 'background-color 0.3s ease'
  }
}

const openSpeakerModal = (speaker) => {
  selectedSpeaker.value = speaker
  showModal.value = true
  document.body.style.overflow = 'hidden'
}

const closeModal = () => {
  showModal.value = false
  selectedSpeaker.value = {}
  document.body.style.overflow = 'auto'
}
</script>

<style scoped>
.aspect-w-1 {
  position: relative;
  padding-bottom: 100%;
}
.aspect-w-1 > img {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
</style>